import { Link } from "react-router";
import { getEntry, listCollection } from "../lib/content.server.js";
import { CATEGORY_LABELS } from "../lib/categories.js";
import { articleJsonLd, breadcrumbJsonLd, buildMeta } from "../lib/seo.js";
import { related } from "../lib/related.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import Prose from "../components/Prose/Prose.jsx";
import EntryCard from "../components/EntryCard/EntryCard.jsx";
import SectionHeader from "../components/SectionHeader/SectionHeader.jsx";

export async function loader({ params }) {
  const entry = getEntry("blog", params.slug);
  if (!entry) throw new Response("Not Found", { status: 404 });
  return { entry, more: related(listCollection("blog"), entry, "category", 3) };
}

export function meta({ loaderData }) {
  if (!loaderData)
    return buildMeta({
      title: "Article not found",
      description: "This article does not exist.",
      path: "/blog",
      noindex: true,
    });
  const { entry } = loaderData;
  const path = `/blog/${entry.slug}`;
  return buildMeta({
    title: entry.title,
    description: entry.description,
    path,
    image: entry.image,
    type: "article",
    jsonLd: [
      articleJsonLd(entry, path),
      breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blog" },
        { name: entry.title, path },
      ]),
    ],
  });
}

export default function Post({ loaderData }) {
  const { entry, more } = loaderData;
  return (
    <>
      <PageHero
        eyebrow={CATEGORY_LABELS[entry.category] || "Article"}
        title={entry.title}
        lead={entry.description}
        image={entry.image}
        imageAlt={entry.imageAlt}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Blog", path: "/blog" },
          { name: entry.title, path: `/blog/${entry.slug}` },
        ]}
      >
        <p>
          {entry.date} · {entry.readingTime} min read{entry.author ? ` · ${entry.author}` : ""}
        </p>
      </PageHero>
      <section className="section">
        <div className="container">
          <Prose html={entry.html} />
          <p style={{ marginTop: "var(--sp-10)" }}>
            Want to see this on your own project? <Link to="/demo">Request a demo</Link>.
          </p>
        </div>
      </section>
      {more.length ? (
        <section className="section section-alt">
          <div className="container">
            <SectionHeader eyebrow="Keep reading" title="Related articles" />
            <div className="grid grid-3">
              {more.map((p) => (
                <EntryCard
                  key={p.slug}
                  kind="post"
                  href={`/blog/${p.slug}`}
                  image={p.image}
                  imageAlt={p.imageAlt}
                  title={p.title}
                  description={p.description}
                  meta={p.date}
                />
              ))}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
